import { each } from '@antv/util';
export function getMaxLabelWidth(labels) {
    var max = 0;
    each(labels, function (label) {
        var bbox = label.getBBox();
        var width = bbox.width;
        if (max < width) {
            max = width;
        }
    });
    return max;
}
//# sourceMappingURL=label.js.map